export const PERMISSION_RESOURCE_CODES = {
  check: 'check',
  dashboard: 'dashboard',
  inventory: 'inventory',
  material: 'material',
  permission: 'permission',
  purchase: 'purchase',
  receive: 'receive',
  rule: 'rule',
  supplier: 'supplier',
  statistics: 'statistics',
  warehouse: 'warehouse',
  workflow: 'workflow',
} as const;

export const PERMISSION_ACTION_CODES = {
  check: {
    view: 'view',
    add: 'add',
    execute: 'execute',
    approve: 'approve',
    cancel: 'cancel',
    reopen: 'reopen',
  },
  dashboard: {
    view: 'view',
  },
  inventory: {
    view: 'view',
    adjust: 'adjust',
    approveAdjustment: 'approveAdjustment',
    freeze: 'freeze',
    transfer: 'transfer',
    transferOutbound: 'transferOutbound',
    transferInbound: 'transferInbound',
    cancelTransfer: 'cancelTransfer',
    export: 'export',
  },
  material: {
    view: 'view',
    add: 'add',
    update: 'update',
    disable: 'disable',
  },
  permission: {},
  purchase: {
    view: 'view',
    add: 'add',
    approve: 'approve',
    order: 'order',
    receive: 'receive',
    cancelOrder: 'cancelOrder',
    closeOrder: 'closeOrder',
    cancelReceipt: 'cancelReceipt',
    exception: 'exception',
    handleException: 'handleException',
  },
  receive: {
    view: 'view',
    add: 'add',
    update: 'update',
    submit: 'submit',
    withdraw: 'withdraw',
    copy: 'copy',
    issue: 'issue',
    approve: 'approve',
    return: 'return',
    confirmReturn: 'confirmReturn',
    cancelReturn: 'cancelReturn',
  },
  rule: {
    view: 'view',
    update: 'update',
    publish: 'publish',
    simulate: 'simulate',
  },
  supplier: {
    view: 'view',
    add: 'add',
    update: 'update',
    disable: 'disable',
    evaluate: 'evaluate',
  },
  statistics: {
    view: 'view',
    export: 'export',
  },
  warehouse: {
    view: 'view',
    add: 'add',
    update: 'update',
    disable: 'disable',
  },
  workflow: {
    view: 'view',
    approve: 'approve',
    transfer: 'transfer',
    terminate: 'terminate',
    markOverdue: 'markOverdue',
  },
};

export const buildPermissionActionKey = (resourceCode: string, actionCode: string) =>
  `${resourceCode}:${actionCode}`;
